import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function TextArea({
  percent,
  className,
  _type,
  type,
  strict,
  onChange,
  uppercase,
  ...props
}) {
  function onInput(e) {
    let value = e.target.value;

    if (uppercase) {
      value = value.toUpperCase();
    }

    e.target.value = value;

    onChange(value);
  }

  return (
    <div>
      <textarea
        rows={4}
        className={classNames("form-control", className)}
        onInput={onInput}
        {...props}
      />
      {/* <br /> */}
    </div>
  );
}
TextArea.defaultProps = defaultProps;
export default TextArea;
